// src/plugins/vuetify.js
// No changes from the previous version are strictly necessary for this layout change.
// Ensure these colors are defined:
// background: '#FFFFFF',
// surface: '#FFFFFF',
// primary: '#1976D2',
// appbar: '#E3F2FD',
// tabinactive: '#0D47A1' (might be useful for app-bar buttons too)
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const myCustomLightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF', // White background for pages
    surface: '#FFFFFF',    // White for card surfaces, drawer background
    primary: '#1976D2',    // Main blue (e.g., active nav item, buttons)
    'primary-darken-1': '#1565C0',
    secondary: '#42A5F5',  // Lighter blue
    'secondary-darken-1': '#1E88E5',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
    appbar: '#E3F2FD',     // Very light blue for the app bar
    tableheader: '#BBDEFB', // Light blue for table headers
    textOnAppBar: '#0D47A1', // Darker blue for text/icons on light appbar for good contrast
    drawerText: '#333333', // Text color for drawer items
    drawerActiveBackground: 'rgba(25, 118, 210, 0.1)', // Light primary color for active drawer item
  }
}

export default createVuetify({
  components: {
    ...components,
    // Explicitly register problematic components if needed
  },
  directives,
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    }
  },
  defaults: {
    // Global defaults for components
    VList: {
      density: 'compact'
    }
  }
})